const Presenter = require('yayson')().Presenter // tslint:disable-line

export const YaysonPresenter = Presenter



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/backends/json-api-backend/presenters/yayson.presenter.ts